import React, { useEffect, useState } from 'react';
import axiosInstance from "../../config/axiosInterceptor";

const GetLiveAmountInRange = () => {
  const [transactions, setTransactions] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  
  const [userId, setUserId] = useState('');
  const [amount, setAmount] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [showModal, setShowModal] = useState(false);
  const [sending, setSending] = useState(false);

  const fetchTransactions = async () => {
    try {
      const res = await axiosInstance.get(`${process.env.REACT_APP_BASEURL1}/admin/livetime/getLiveAmountInRange`, {
        params: {
          userId,
          amount,
          startDate,
          endDate,
          page,
          limit
        }
      });

      if (res.data.success) {
        setTransactions(res.data.transactions);
        setTotalAmount(res.data.totalAmount);
        setTotalCount(res.data.totalCount);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (userId && startDate && endDate) {
      fetchTransactions();
    }
  }, [userId, amount, startDate, endDate, page, limit]);

  const totalPages = Math.ceil(totalCount / limit);

  const sendMcoin = async () => {
    try {
      setSending(true);
      const res = await axiosInstance.post(`${process.env.REACT_APP_BASEURL1}/admin/livetime/sendMCoins`, {
        username: userId,
        amount: totalAmount || amount
      });
      alert(res.data.message || "Mcoin sent!");
    } catch (err) {
      console.error(err);
      alert("Failed to send Mcoin");
    } finally {
      setSending(false);
      setShowModal(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '900px', margin: 'auto' }}>
      <h2>Transaction List</h2>

      <div style={{ marginBottom: '10px', display: 'flex', gap: '10px' }}>
        <input type="text" placeholder="User ID" value={userId} onChange={(e) => setUserId(e.target.value)} />
        <input type="text" placeholder="Amount" value={amount} onChange={(e) => setAmount(e.target.value)} />
        <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        <button onClick={() => { setPage(1); fetchTransactions(); }}>Search</button>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <p><strong>Total Amount:</strong> {totalAmount}</p>
        {userId && (totalAmount || amount) > 0 && (
          <button onClick={() => setShowModal(true)}>Send Mcoin</button>
        )}
      </div>

      <div style={{ marginBottom: '10px' }}>
        Entries per page:
        <select value={limit} onChange={(e) => { setLimit(Number(e.target.value)); setPage(1); }}>
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={25}>25</option>
        </select>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: '#f0f0f0' }}>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Amount</th>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Username</th>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Other Username</th>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Created At</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((tx, index) => (
            <tr key={index}>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{tx.amount}</td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{tx.username}</td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{tx.otherUsername}</td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{new Date(tx.createdAt).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ marginTop: '15px', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <button onClick={() => setPage((p) => Math.max(p - 1, 1))} disabled={page === 1}>Prev</button>
        <span>Page {page} of {totalPages}</span>
        <button onClick={() => setPage((p) => Math.min(p + 1, totalPages))} disabled={page === totalPages}>Next</button>
      </div>

      {showModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <div style={{ background: '#fff', padding: '20px', borderRadius: '8px', width: '300px' }}>
            <h3>Send Mcoin</h3>
            <p><strong>Username:</strong> {userId}</p>
            <p><strong>Amount:</strong> {totalAmount || amount}</p>
            <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'space-between' }}>
              <button onClick={() => setShowModal(false)} disabled={sending}>Cancel</button>
              <button onClick={sendMcoin} disabled={sending}>{sending ? 'Sending...' : 'Send'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GetLiveAmountInRange;
